import clsx from 'clsx'

import { FavoriteOutlinedIcon } from '@/components/icons'
import { FavoriteFilledIcon } from '@/components/icons/FavoriteFilled'
import { Icon } from '@/components/ui'

import { FavoriteTagProps } from './type'

export const FavoriteTag = ({ isFavorite }: FavoriteTagProps) => {
  return (
    <span
      className={clsx(
        'tw-h-[18px] tw-w-[18px]',
        'tw-flex tw-items-center tw-justify-center',
        'tw-rounded-sm',
        isFavorite ? 'tw-bg-accentYellow-50' : 'tw-bg-gray-100'
      )}
    >
      <div className={clsx('tw-relative tw-h-full tw-w-full')}>
        <Icon
          icon={FavoriteFilledIcon}
          size={'lg'}
          color={isFavorite ? 'yellow' : 'disabled'}
          className={clsx(
            'tw-absolute',
            isFavorite
              ? '!tw-fill-accentYellow-500 !tw-stroke-labelBlue-500 !tw-text-accentYellow-500'
              : ''
          )}
        />
        <Icon
          icon={FavoriteOutlinedIcon}
          size={'lg'}
          color={isFavorite ? 'primary' : 'disabled'}
          className={clsx(
            'tw-absolute',
            isFavorite ? '!tw-fill-primary-400' : ''
          )}
        />
      </div>
    </span>
  )
}
